import { motion } from "motion/react";
import { Mail, Clock, MapPin, MessageCircle } from "lucide-react";

export function ContatoPage() {
  return (
    <div className="min-h-screen bg-white pt-20">
      <section className="py-24 px-6 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Fale com a <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                BusiFarm
              </span>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Nosso time está pronto para ajudar você a transformar a gestão do seu negócio
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">
                  Entre em contato
                </h2>

                <div className="space-y-6">
                  {/* WhatsApp */}
                  <motion.a
                    href="https://wa.me/5587999906154"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all border border-gray-100 group"
                    whileHover={{ y: -4 }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      <MessageCircle className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">WhatsApp</h3>
                      <p className="text-gray-600">+55 87 9 9990-6154</p>
                      <p className="text-sm text-green-600 mt-1">Clique para conversar</p>
                    </div>
                  </motion.a>

                  {/* Email */}
                  <motion.a
                    href="mailto:contact@busifarm.com"
                    className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all border border-gray-100 group"
                    whileHover={{ y: -4 }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      <Mail className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">E-mail</h3>
                      <p className="text-gray-600">contact@busifarm.com</p>
                      <p className="text-sm text-blue-600 mt-1">Clique para enviar e-mail</p>
                    </div>
                  </motion.a>

                  {/* Horário */}
                  <motion.div
                    className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-gray-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Clock className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">Horário de Atendimento</h3>
                      <p className="text-gray-600">Segunda a Sexta: 9h às 18h</p>
                      <p className="text-sm text-gray-500 mt-1">
                        Sábados, domingos e feriados não atendemos
                      </p>
                    </div>
                  </motion.div>

                  {/* Localização */}
                  <motion.div
                    className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-gray-100"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1">Nossa Presença</h3>
                      <p className="text-gray-600">Time remoto em todo o Brasil</p>
                      <p className="text-sm text-gray-500 mt-1">
                        Atendemos empresas de qualquer região do país
                      </p>
                    </div>
                  </motion.div>
                </div>
              </div>
            </motion.div>

            {/* CTA Card */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
              className="lg:sticky lg:top-24 h-fit"
            >
              <div className="bg-gradient-to-br from-green-600 via-green-700 to-blue-700 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
                <div className="absolute inset-0">
                  <motion.div
                    className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"
                    animate={{
                      scale: [1, 1.2, 1],
                      x: [0, 20, 0],
                      y: [0, -20, 0],
                    }}
                    transition={{
                      duration: 10,
                      repeat: Infinity,
                      ease: "easeInOut"
                    }}
                  />
                </div>

                <div className="relative z-10">
                  <h2 className="text-3xl md:text-4xl font-bold mb-4">
                    Prefere uma demonstração?
                  </h2>
                  <p className="text-white/90 text-lg mb-8">
                    Agende uma conversa sem compromisso e veja a plataforma funcionando na prática.
                  </p>

                  <div className="space-y-4 mb-8">
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      </div>
                      <span className="text-white/90">Apresentação personalizada</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      </div>
                      <span className="text-white/90">Tire todas as suas dúvidas</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                        <div className="w-2 h-2 bg-white rounded-full"></div>
                      </div>
                      <span className="text-white/90">Sem compromisso</span>
                    </div>
                  </div>

                  <a
                    href="/demonstracao"
                    className="inline-block w-full text-center px-8 py-4 bg-white text-green-700 rounded-xl hover:shadow-2xl transition-all font-semibold"
                  >
                    Solicitar demonstração
                  </a>
                </div>
              </div>

              {/* Quick Contact */}
              <div className="mt-6 p-6 bg-gray-50 rounded-2xl border border-gray-200">
                <h3 className="font-bold text-gray-900 mb-4">Contato rápido</h3>
                <div className="space-y-3">
                  <a
                    href="https://wa.me/5587999906154"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 p-3 bg-white rounded-xl hover:shadow-md transition-all group"
                  >
                    <MessageCircle className="w-5 h-5 text-green-600 group-hover:scale-110 transition-transform" />
                    <span className="text-gray-700 group-hover:text-green-600 transition-colors">
                      Falar no WhatsApp
                    </span>
                  </a>
                  <a
                    href="mailto:contact@busifarm.com"
                    className="flex items-center gap-3 p-3 bg-white rounded-xl hover:shadow-md transition-all group"
                  >
                    <Mail className="w-5 h-5 text-blue-600 group-hover:scale-110 transition-transform" />
                    <span className="text-gray-700 group-hover:text-blue-600 transition-colors">
                      Enviar e-mail
                    </span>
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Perguntas frequentes
            </h2>
            <p className="text-xl text-gray-600">
              Respostas rápidas para as dúvidas mais comuns
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                question: "Quanto tempo leva para implementar?",
                answer: "O tempo de implementação varia de acordo com o tamanho da operação, mas geralmente entre 2 a 4 semanas com acompanhamento completo da nossa equipe."
              },
              {
                question: "Vocês oferecem treinamento?",
                answer: "Sim! O treinamento completo da equipe está incluído na implantação, além de suporte contínuo após o go-live."
              },
              {
                question: "Como funciona o suporte?",
                answer: "Oferecemos suporte via WhatsApp e e-mail em horário comercial (9h às 18h, segunda a sexta). Casos críticos têm atendimento prioritário."
              },
              {
                question: "A plataforma funciona offline?",
                answer: "A BusiFarm é 100% cloud, portanto requer conexão com internet. Isso garante que seus dados estejam sempre sincronizados e seguros."
              },
            ].map((faq, i) => (
              <motion.div
                key={i}
                className="bg-gray-50 rounded-2xl p-6 hover:bg-gray-100 transition-colors"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <h3 className="font-bold text-gray-900 mb-2">{faq.question}</h3>
                <p className="text-gray-600">{faq.answer}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
